<template>
  <div class="chat-container">
    <el-container class="main-container">
      <!-- 左侧区域 -->
      <el-aside width="50%" class="gdp-aside">
        <el-card v-if="regionGDP" class="gdp-card">
          <template #header>
            <div class="card-header">
              <span
                >{{ regionGDP.getGdp.local }}
                {{ regionGDP.getGdp.time }} GDP数据</span
              >
              <span>单位: {{ regionGDP.getGdp.unit }}</span>
            </div>
          </template>

          <!-- GDP总量 -->
          <div class="gdp-total">
            <h3>GDP总量</h3>
            <p class="total-value">{{ regionGDP.getGdp.data }}</p>
          </div>

          <!-- 三产结构 -->
          <div class="section">
            <h3>三产结构</h3>
            <el-table :data="regionGDP.gdpEstateStatistics" style="width: 100%">
              <el-table-column prop="key" label="产业" width="120" empty-text="暂无数据" />
              <el-table-column prop="percent" label="数值" />
              <el-table-column prop="value" label="占比" />
            </el-table>
          </div>

          <!-- 投资消费出口 -->
          <div class="section">
            <h3>投资消费出口</h3>
            <el-table :data="regionGDP.getGdpDistribution" style="width: 100%">
              <el-table-column prop="key" label="项目" width="120" />
              <el-table-column prop="percent" label="数值" />
              <el-table-column prop="value" label="占比" />
            </el-table>
          </div>

          <!-- 人口数据 -->
          <div class="section">
            <h3>人口数据</h3>
            <el-table :data="regionGDP.getPopulationSum" style="width: 100%">
              <el-table-column prop="key" label="类型" width="120" />
              <el-table-column prop="percent" label="数值" />
              <el-table-column prop="value" label="占比" />
            </el-table>
          </div>

          <!-- 年龄构成 -->
          <div class="section">
            <h3>年龄构成</h3>
            <el-table :data="regionGDP.getAgeRatio" style="width: 100%">
              <el-table-column prop="key" label="年龄段" width="120" />
              <el-table-column prop="percent" label="数值" />
              <el-table-column prop="value" label="占比" />
            </el-table>
          </div>

          <!-- 政府领导 -->
          <div class="section">
            <h3>政府领导</h3>
            <el-table :data="regionGDP.getLeaderName" style="width: 100%">
              <el-table-column prop="key" label="职务" width="180" />
              <el-table-column prop="value" label="姓名" />
              <el-table-column prop="percent" label="简介" />
            </el-table>
          </div>

          <!-- 当地政府五年产业规划 -->
          <div class="section">
            <h3>当地政府五年产业规划</h3>

            <!-- 主导产业 -->
            <el-collapse accordion>
              <el-collapse-item title="主导产业" name="1">
                <div style="margin-bottom: 10px">
                  <h4>产业列表</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '主导产业'
                      )?.value.estateList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '主导产业'
                      )?.value.estateList"
                      :key="'main-industry-' + index"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
                <div>
                  <h4>代表性企业</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '主导产业'
                      )?.value.companyNameList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '主导产业'
                      )?.value.companyNameList"
                      :key="'main-company-' + index"
                      type="success"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
              </el-collapse-item>

              <!-- 优势产业 -->
              <el-collapse-item title="优势产业" name="2">
                <div style="margin-bottom: 10px">
                  <h4>产业列表</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '优势产业'
                      )?.value.estateList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '优势产业'
                      )?.value.estateList"
                      :key="'advantage-industry-' + index"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
                <div>
                  <h4>代表性企业</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '优势产业'
                      )?.value.companyNameList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '优势产业'
                      )?.value.companyNameList"
                      :key="'advantage-company-' + index"
                      type="success"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
              </el-collapse-item>

              <!-- 未来产业 -->
              <el-collapse-item title="未来产业" name="3">
                <div style="margin-bottom: 10px">
                  <h4>产业列表</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '未来产业'
                      )?.value.estateList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '未来产业'
                      )?.value.estateList"
                      :key="'future-industry-' + index"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
                <div>
                  <h4>代表性企业</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '未来产业'
                      )?.value.companyNameList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '未来产业'
                      )?.value.companyNameList"
                      :key="'future-company-' + index"
                      type="success"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
              </el-collapse-item>

              <!-- 战略性新兴产业 -->
              <el-collapse-item title="战略性新兴产业" name="4">
                <div style="margin-bottom: 10px">
                  <h4>产业列表</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '战略性新兴产业'
                      )?.value.estateList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '战略性新兴产业'
                      )?.value.estateList"
                      :key="'strategic-industry-' + index"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
                <div>
                  <h4>代表性企业</h4>
                  <template
                    v-if="
                      regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '战略性新兴产业'
                      )?.value.companyNameList?.length > 0
                    "
                  >
                    <el-tag
                      v-for="(item, index) in regionGDP.getFiveYearPlan.find(
                        (p) => p.key === '战略性新兴产业'
                      )?.value.companyNameList"
                      :key="'strategic-company-' + index"
                      type="success"
                      style="margin-right: 10px; margin-bottom: 5px"
                    >
                      {{ item }}
                    </el-tag>
                  </template>
                  <div v-else>暂无数据</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <!-- 能源价格 -->
          <div class="section">
            <h3>能源价格</h3>

            <!-- 供电 -->
            <el-collapse accordion>
              <el-collapse-item title="供电价格" name="1">
                <el-table
                  :data="regionGDP.getElectrovalenceStatistics"
                  style="width: 100%"
                >
                  <el-table-column prop="key" label="电压等级" />
                  <el-table-column prop="value" label="价格" />
                </el-table>
              </el-collapse-item>

              <!-- 供水 -->
              <el-collapse-item title="供水价格" name="2">
                <el-table
                  :data="regionGDP.getWaterSupplyStatistics"
                  style="width: 100%"
                >
                  <el-table-column prop="key" label="用水类型" />
                  <el-table-column prop="value" label="价格" />
                </el-table>
              </el-collapse-item>

              <!-- 蒸汽 -->
              <el-collapse-item title="蒸汽价格" name="3">
                <el-table
                  :data="regionGDP.getSteamStatistics"
                  style="width: 100%"
                >
                  <el-table-column prop="key" label="类型" />
                  <el-table-column prop="value" label="价格" />
                </el-table>
              </el-collapse-item>

              <!-- 天然气 -->
              <el-collapse-item title="天然气价格" name="4">
                <el-table
                  :data="regionGDP.getNaturalGasStatistics"
                  style="width: 100%"
                >
                  <el-table-column prop="key" label="类型" />
                  <el-table-column prop="value" label="价格" />
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>

          <!-- 运输价格 -->
          <div class="section">
            <h3>运输价格</h3>
            <el-table
              :data="regionGDP.getTransportationCostStatistics"
              style="width: 100%"
            >
              <el-table-column prop="key" label="运输方式" />
              <el-table-column prop="value" label="价格" />
            </el-table>
          </div>

          <!-- 租金信息 -->
          <div class="section">
            <h3>租金信息</h3>
            <el-table :data="regionGDP.getRentStatistics" style="width: 100%">
              <el-table-column prop="key" label="类型" />
              <el-table-column prop="value" label="价格" />
            </el-table>
          </div>

          <!-- 土地信息 -->
          <div class="section">
            <h3>土地信息</h3>
            <el-table
              :data="regionGDP.getGroundRentStatistics"
              style="width: 100%"
            >
              <el-table-column prop="key" label="类型" />
              <el-table-column prop="value" label="价格" />
            </el-table>
          </div>

          <!-- 重点地块 -->
          <div class="section">
            <h3>重点地块</h3>
            <el-card shadow="never" class="box-card">
              <div
                v-for="(item, index) in JSON.parse(
                  regionGDP.getKeyPlotStatistics[0].value
                )"
                :key="index"
                class="text item"
              >
                <el-tag type="warning">{{ index + 1 }}</el-tag> {{ item }}
              </div>
            </el-card>
          </div>

          <!-- 数据来源链接 -->
          <div class="section">
            <h3>数据来源</h3>
            <el-card shadow="never" class="box-card">
              <div
                v-for="(item, index) in regionGDP.getLinks"
                :key="index"
                class="text item"
              >
                <a :href="item.link" target="_blank">{{ item.name }}</a>
              </div>
            </el-card>
          </div>
        </el-card>
        <!-- https://plc.shanhe.link/assets/NOLL_DATA.png -->
        <el-empty
          v-else
          style="margin-top: 15%"
          description="暂无数据"
          image="https://plc.shanhe.link/assets/NOLL_DATA.png"
        ></el-empty>
      </el-aside>
      <!-- 右侧区域 -->
      <el-main class="chat-main">
        <!-- 添加操作栏 -->
        <div class="operation-bar">
          <div class="operation-bar-title">
            <i class="el-icon-copy-document"></i> 分析报告
          </div>
          <el-button
            type="primary"
            size="small"
            :disabled="!canExport"
            @click="handleExport"
            style="background-color: #3366ff; border: none"
          >
            导出分析报告
          </el-button>
        </div>
        <div
          class="chat-messages"
          :style="{ height: messageContainerHeight + 'px', overflow: 'auto' }"
          ref="messageContainer"
        >
          <div v-if="messages.length > 0">
            <div
              v-for="(message, index) in messages"
              :key="index"
              class="message"
              :class="message.role"
            >
              <div class="avatar">
                <img v-if="message.role === 'user'" :src="userAvatar" alt="" />
                <div v-else>🤖</div>
              </div>
              <div
                class="content chat-text-container"
                :style="{ flex: message.role === 'user' ? 'none' : '1' }"
              >
                <mavon-editor
                  v-if="message.role === 'assistant'"
                  v-model="message.content"
                  :toolbars="markdownOptions"
                  :subfield="false"
                  defaultOpen="preview"
                  preview-background="#f5f7fa"
                  :boxShadow="false"
                  :ishljs="true"
                  :editable="false"
                />
                <div v-else>{{ message.content }}</div>
                <div
                  class="detail-report"
                  v-if="message.role === 'assistant'"
                  :class="{ disabled: isTyping }"
                  @click="!isTyping && handleDetailReport(index)"
                >
                  详情报告
                </div>
                <div
                  class="download-report"
                  v-if="message.role === 'assistant'"
                  :class="{ disabled: isTyping }"
                  @click="!isTyping && handleDownloadReport(index)"
                >
                  下载当前报告
                </div>
              </div>
            </div>
          </div>
          <div v-if="isNoData">
            <el-skeleton :rows="4" />
            <el-empty
              :image-size="120"
              description="暂无分析内容"
              image="https://plc.shanhe.link/assets/NOLL_DATA.png"
            ></el-empty>
          </div>
          <div v-if="isTyping" class="message assistant">
            <div class="avatar">🤖</div>
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        <div class="chat-input">
          <el-select
            v-model="selectedYear"
            placeholder="选择年份"
            style="width: 120px"
          >
            <el-option
              v-for="year in yearOptions"
              :key="year"
              :label="year"
              :value="year"
            >
            </el-option>
          </el-select>
          <el-autocomplete
            v-model="inputMessage"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="true"
            :disabled="isTyping"
            placeholder="请输入省份、城市或区域..."
            @select="handleSelect"
            @keyup.enter.native="getRegionGdpPreconditioning"
            style="width: 100%"
            clearable
            class="input-with-select"
          >
            <template slot-scope="{ item }">
              <div class="suggestion-item">
                <span>{{ item.name }}</span>
                <span
                  class="suggestion-type"
                  @click="getRegionGdpPreconditioningSend(item.name)"
                  >{{ item.type }}</span
                >
              </div>
            </template>
          </el-autocomplete>
          <el-button
            type="primary"
            :loading="isTyping"
            :disabled="isTyping || !isValidInput"
            @click="getRegionGdpPreconditioning"
            style="background-color: #3366ff; border: none"
          >
            发送
          </el-button>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import WebSocketClient from "@/utils/websocket";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
import request from "@/utils/request";
import ExportFile from "@/utils/exportFile";
import { getUserInfo } from "@/utils/userInfo";
import { GET_USER_INFO_API } from "@/utils/requestUrl";

export default {
  name: "AiChat",
  components: {
    mavonEditor,
  },
  data() {
    return {
      // WebSocket连接
      ws: null,
      // 消息列表
      messages: [],
      // 输入框内容
      inputMessage: "",
      // 是否正在输入
      isTyping: false,
      // 最大对话轮次
      maxRounds: 5,
      // Markdown编辑器配置
      markdownOptions: {
        // 工具栏配置
        bold: false,
        // 斜体
        italic: false,
        // 标题
        header: false,
        // 下划线
        underline: false,
        // 删除线
        strikethrough: false,
        // 标记
        mark: false,
        // 上标
        superscript: false,
        // 下标
        subscript: false,
        // 引用
        quote: false,
        // 有序列表
        ol: false,
        // 无序列表
        ul: false,
        // 链接
        link: false,
        // 图片链接
        imagelink: false,
        // 代码
        code: false,
        // 表格
        table: false,
        // 全屏
        fullscreen: false,
        // 阅读模式
        readmodel: false,
        // HTML代码
        htmlcode: false,
        // 帮助
        help: false,
        // 撤销
        undo: false,
        // 重做
        redo: false,
        // 清空
        trash: false,
        // 保存
        save: false,
        // 导航
        navigation: false,
      },
      // 控制是否自动滚动
      autoScroll: true,
      // 用户滚动计时器
      userScrollTimer: null,
      // 记录上次滚动位置
      lastScrollTop: 0,
      // 消息容器高度
      messageContainerHeight: 0,
      // 省份信息数据
      provinceInfoData: [],
      // 区域数据
      regionData: [],
      // 搜索建议
      suggestions: [],
      // 用户选择的区域
      selectedRegion: null,
      // 是否可以导出
      canExport: false,
      // token
      token: null,
      // 区域GDP
      regionGDP: null,
      // 年份选项
      yearOptions: [2023, 2024],
      // 选中的年份
      selectedYear: 2024,
      // 是否显示空数据
      isNoData: true,
    };
  },
  computed: {
    // 验证输入
    isValidInput() {
      return (
        this.selectedRegion &&
        this.inputMessage.trim() === this.selectedRegion.name
      );
    },
  },
  created() {
    // 获取区域数据
    this.fetchRegionData();
    // 获取token
    this.token = this.$uuid.get();
  },
  mounted() {
    // 初始化WebSocket
    this.initWebSocket();
    // 添加滚动监听
    let messageContainer = this.$refs.messageContainer;
    messageContainer.addEventListener("scroll", this.handleScroll);
    messageContainer.style.height = "100%";
    messageContainer.style.paddingTop = "10px";
    this.messageContainerHeight = messageContainer.clientHeight - 40;

    // 设置容器高度
    this.updateContainerHeight();
    // 监听窗口大小变化
    window.addEventListener("resize", this.updateContainerHeight);
    // 获取用户头像
    this.userAvatar = GET_USER_INFO_API + getUserInfo().avatar;
  },
  // 销毁时移除滚动监听
  beforeDestroy() {
    if (this.ws) {
      this.ws.close();
    }
    // 移除滚动监听
    this.$refs.messageContainer.removeEventListener(
      "scroll",
      this.handleScroll
    );
    // 清除计时器
    if (this.userScrollTimer) {
      clearTimeout(this.userScrollTimer);
    }

    // 移除窗口大小变化监听
    window.removeEventListener("resize", this.updateContainerHeight);
  },
  methods: {
    // 初始化WebSocket
    initWebSocket() {
      this.ws = new WebSocketClient(null, null, this.token);
      this.ws
        .connect()
        .then(() => {
          console.info("WebSocket连接成功");
        })
        .catch((error) => {
          this.$message.error("连接失败，请刷新页面重试");
          console.error("连接失败:", error);
        });

      this.ws.onMessage(this.handleMessage);
    },

    // 获取区域数据
    fetchRegionData() {
      request
        .get("conditions/province")
        .then((res) => {
          this.regionData = res;
          this.processRegionData();
        })
        .catch((error) => {
          console.error("获取区域数据失败:", error);
        });
    },

    // 处理区域数据，转换为搜索建议格式
    processRegionData() {
      this.suggestions = [];

      this.regionData.forEach((province) => {
        // 添加省份
        this.suggestions.push({
          id: province.provinceId,
          name: province.provinceName,
          type: "省份",
          longitude: province.longitude,
          latitude: province.latitude,
        });

        // 添加城市
        province.children?.forEach((city) => {
          this.suggestions.push({
            id: city.cityId,
            name: city.cityName,
            type: "城市",
            longitude: city.longitude,
            latitude: city.latitude,
          });

          // 添加区域
          city.children?.forEach((area) => {
            this.suggestions.push({
              id: area.areaId,
              name: area.areaName,
              type: "区域",
              longitude: area.longitude,
              latitude: area.latitude,
            });
          });

        });
      });
    },

    // 搜索建议
    querySearch(queryString, cb) {
      const results = queryString
        ? this.suggestions.filter((item) => {
            return item.name.toLowerCase().includes(queryString.toLowerCase());
          })
        : this.suggestions;

      cb(results);
    },

    // 选择建议
    handleSelect(item) {
      this.selectedRegion = item;
      this.inputMessage = item.name;
    },

    // 处理WebSocket消息
    handleMessage(message) {
      try {
        const data =
          typeof message === "string" ? JSON.parse(message) : message;

        switch (data.type) {
          case "start":
            this.isNoData = false;
            this.isTyping = true;
            this.canExport = false; // 开始分析时禁用导出
            break;

          case "content":
            if (data.content) {
              this.updateLastMessage(data.content);
            }
            this.isTyping = true;
            break;

          case "end":
            clearTimeout(this.userScrollTimer);
            this.autoScroll = false;
            this.isTyping = false;
            this.canExport = true; // 分析完成后启用导出
            break;

          case "error":
            clearTimeout(this.userScrollTimer);
            this.$message.error(data.content || "发生错误，请重试");
            this.isTyping = false;
            this.autoScroll = false;
            this.canExport = false; // 发生错误时禁用导出
            break;
        }
      } catch (error) {
        console.error("消息处理错误:", error);
      }
    },

    // 处理滚动事件
    handleScroll() {
      if (!this.isTyping) return;
      const container = this.$refs.messageContainer;
      const { scrollTop, scrollHeight, clientHeight } = container;

      // 检测是否是向上滚动
      if (scrollTop < this.lastScrollTop) {
        this.autoScroll = false;

        // 清除之前的计时器
        if (this.userScrollTimer) {
          clearTimeout(this.userScrollTimer);
        }

        // 设置新的计时器
        this.userScrollTimer = setTimeout(() => {
          this.autoScroll = true;
          // 如果开启自动滚动，立即滚动到底部
          if (this.autoScroll) {
            this.scrollToBottom();
          }
        }, 3000);
      }

      // 如果滚动到底部，开启自动滚动
      if (scrollHeight - scrollTop - clientHeight < 10) {
        this.autoScroll = true;
      }

      // 更新上次滚动位置
      this.lastScrollTop = scrollTop;
    },

    // 滚动到底部
    scrollToBottom() {
      // 只有在自动滚动开启时才滚动到底部
      if (this.autoScroll) {
        this.$nextTick(() => {
          const container = this.$refs.messageContainer;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        });
      }
    },

    // 更新最后一条消息
    updateLastMessage(content) {
      const lastMessage = this.messages[this.messages.length - 1];
      if (lastMessage && lastMessage.role === "assistant") {
        lastMessage.content += content;
      } else {
        this.messages.push({
          role: "assistant",
          content: content,
        });
        // AI回复后也要检查对话轮次
        this.checkAndRemoveOldMessages();
      }
      this.scrollToBottom();
    },

    // 检查并删除旧对话
    checkAndRemoveOldMessages() {
      // 计算当前对话轮次（一问一答为一轮）
      const currentRounds = Math.floor(this.messages.length / 2);

      // 如果超过最大轮次，删除最早的一轮对话（两条消息）
      if (currentRounds > this.maxRounds) {
        this.messages.splice(0, 2);
      }
    },

    // 发送消息
    handleSend(msg = null) {
      if (!this.isValidInput) {
        this.$message.warning("请选择有效的地区");
        return;
      }

      const message = this.inputMessage.trim();
      if (!message || this.isTyping) return;

      // 发送消息时重新开启自动滚动
      this.autoScroll = true;

      // 添加用户消息
      this.messages.push({
        role: "user",
        content: msg ? msg : message,
      });

      this.isTyping = true;

      // 检查对话轮次并删除最早的对话
      this.checkAndRemoveOldMessages();
      // 发送消息后清空输入
      setTimeout(() => {
        // 清空输入
        this.selectedRegion = null;
        this.inputMessage = "";
        this.scrollToBottom();
      }, 500);
    },

    // 获取预处理GDP数据并发送
    getRegionGdpPreconditioningSend(name) {
      this.inputMessage = name;
      this.getRegionGdpPreconditioning();
    },

    // 获取预处理GDP数据
    getRegionGdpPreconditioning() {
      if (!this.inputMessage) {
        this.$message.warning("请输入城市名称");
        return;
      }
      request
        .get("/regionalAnalysis/regionGdpPreconditioning", {
          params: {
            region: this.inputMessage,
            token: this.token,
            year: this.selectedYear,
          },
        })
        .then((res) => {
          this.regionGDP = JSON.parse(res);
          this.isTyping = false;
          this.isNoData = false;
          this.canExport = false; // 开始分析时禁用导出
          this.handleSend();
        })
        .catch((error) => {
          console.error("获取预处理GDP数据失败:", error);
          this.$message.warning("输入的城市名称不正确，请重新输入");
        });
    },

    /**
     * 处理详情报告点击事件
     * @param {number} index - 消息索引
     */
    handleDetailReport(index) {
      // 防止AI正在输出时点击
      if (this.isTyping) {
        return;
      }

      console.log(this.messages[index - 1].content);

      // 设置正在输入状态，禁用输入框
      this.isTyping = true;
      this.autoScroll = true; // 重新开启自动滚动

      this.messages.push({
        role: "user",
        content: this.messages[index - 1].content + "的详情报告",
      });

      request
        .get("/regionalAnalysis/detailReport", {
          params: {
            region: this.messages[index - 1].content + this.selectedYear + "年",
            token: this.token,
          },
        })
        .then((res) => {
          this.isNoData = false;
          this.canExport = false; // 开始分析时禁用导出
          // 注意：这里不要设置 isTyping = false，应该等待 WebSocket 消息
        })
        .catch((error) => {
          console.error("获取详情报告失败:", error);
          this.$message.error("获取详情报告失败，请重试");
          this.isTyping = false; // 出错时恢复输入状态
        });
    },

    // 处理导出
    async handleExport() {
      if (!this.messages.length) {
        this.$message.warning("暂无可导出的分析内容");
        return;
      }

      try {
        // 获取最后一次AI的回复
        const lastAiMessage = [...this.messages]
          .reverse()
          .find((msg) => msg.role === "assistant");
        if (!lastAiMessage) {
          this.$message.warning("未找到AI分析内容");
          return;
        }

        const result = await ExportFile.exportWord(
          lastAiMessage.content,
          "区域分析报告",
          {
            styles: `
              body { 
                font-family: "Microsoft YaHei", Arial, sans-serif; 
                line-height: 1.8; 
                padding: 20px;
                max-width: 800px;
                margin: 0 auto;
              }
              h1 { 
                color: #333; 
                border-bottom: 2px solid #409EFF;
                padding-bottom: 10px;
                margin-bottom: 20px;
                font-size: 24px;
              }
              h2 {
                color: #444;
                font-size: 20px;
                margin-top: 25px;
              }
              h3 {
                color: #555;
                font-size: 18px;
              }
              p { 
                margin: 12px 0;
                color: #333;
                text-align: justify;
              }
            `,
          }
        );

        if (result.success) {
          this.$message.success("报告导出成功");
        } else {
          throw new Error(result.message);
        }
      } catch (error) {
        console.error("导出报告失败:", error);
        this.$message.error("导出报告失败，请重试");
      }
    },

    // 处理下载当前报告
    async handleDownloadReport(index) {
      // 防止AI正在输出时点击
      if (this.isTyping) {
        return;
      }

      try {
        // 获取当前消息内容
        const currentMessage = this.messages[index];
        if (!currentMessage || currentMessage.role !== "assistant") {
          this.$message.warning("无法下载，未找到有效的报告内容");
          return;
        }

        // 获取区域名称作为报告标题
        const regionName = this.regionGDP?.getGdp?.local || "区域";
        const reportTitle = `${regionName}${this.selectedYear}年分析报告`;

        // 导出Word文档
        const result = await ExportFile.exportWord(
          currentMessage.content,
          reportTitle,
          {
            styles: `
              body { 
                font-family: "Microsoft YaHei", Arial, sans-serif; 
                line-height: 1.8; 
                padding: 20px;
                max-width: 800px;
                margin: 0 auto;
              }
              h1 { 
                color: #333; 
                border-bottom: 2px solid #409EFF;
                padding-bottom: 10px;
                margin-bottom: 20px;
                font-size: 24px;
              }
              h2 {
                color: #444;
                font-size: 20px;
                margin-top: 25px;
              }
              h3 {
                color: #555;
                font-size: 18px;
              }
              p { 
                margin: 12px 0;
                color: #333;
                text-align: justify;
              }
            `,
          }
        );

        if (result.success) {
          this.$message.success("报告下载成功");
        } else {
          throw new Error(result.message);
        }
      } catch (error) {
        console.error("下载报告失败:", error);
        this.$message.error("下载报告失败，请重试");
      }
    },

    // 更新容器高度
    updateContainerHeight() {
      this.$nextTick(() => {
        const messageContainer = this.$refs.messageContainer;
        if (messageContainer) {
          // 计算消息容器的高度: 视窗高度 - 顶部空间 - 底部输入框 - 操作栏
          const viewportHeight = document.documentElement.clientHeight;
          const topOffset = messageContainer.getBoundingClientRect().top;
          const inputHeight = 50; // 输入框高度
          const operationBarHeight = 50; // 操作栏高度
          const padding = 20; // 额外边距

          this.messageContainerHeight =
            viewportHeight -
            topOffset -
            inputHeight -
            operationBarHeight -
            padding;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f7f9fc;
  overflow: hidden;
}

.main-container {
  height: 100%;
  overflow: hidden;
}

.gdp-aside {
  // height: 100%;
  margin: 10px 0 10px 10px;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  // border-right: 1px solid #ebeef5;

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #909399;
  }
}

.chat-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  overflow: hidden;
}

.gdp-card {
  margin-bottom: 20px;
  border: none !important;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #3366ff;
  }

  .gdp-total {
    text-align: center;
    margin: 20px 0;
    background-color: #f8faff;
    padding: 15px;
    border-radius: 8px;

    h3 {
      margin-bottom: 10px;
      color: #606266;
    }

    .total-value {
      font-size: 28px;
      color: #3366ff;
      font-weight: bold;
    }
  }

  .section {
    margin: 20px 0;

    h3 {
      margin-bottom: 15px;
      color: #606266;
      font-size: 16px;
      border-radius: 4px;
      padding-left: 10px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #3366ff;
        border-radius: 2px;
      }
    }

    h4 {
      margin: 10px 0;
      color: #909399;
    }

    .el-collapse {
      border: none;

      .el-collapse-item {
        margin-bottom: 10px;

        .el-collapse-item__header {
          background-color: #f5f7fa;
          border-radius: 4px;
          border: none;
          padding: 0 10px;
          height: 40px;
          line-height: 40px;

          &.is-active {
            color: #409eff;
          }
        }

        .el-collapse-item__wrap {
          border: none;
        }

        .el-collapse-item__content {
          padding: 15px;
          background-color: #f9f9f9;
          border-radius: 0 0 4px 4px;
        }
      }
    }

    .el-tag {
      margin-right: 8px;
      margin-bottom: 8px;
    }

    .box-card {
      background-color: #f9f9f9;
      border: none;

      .text.item {
        padding: 8px 0;

        a {
          color: #409eff;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

.chat-messages {
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  flex: 1;

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #909399;
  }

  .message {
    display: flex;
    margin-bottom: 20px;

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #f0f0f0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-right: 12px;
      flex-shrink: 0;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .content {
      flex: 1;
      max-width: 85%;

      .detail-report {
        margin-top: 10px;
        text-align: right;
        color: #3366ff;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        transition: all 0.3s ease;

        &:hover:not(.disabled) {
          text-decoration: underline;
        }

        &.disabled {
          color: #c0c4cc;
          cursor: not-allowed;
          opacity: 0.6;
        }
      }

      .download-report {
        margin-top: 5px;
        text-align: right;
        color: #3366ff;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        transition: all 0.3s ease;

        &:hover:not(.disabled) {
          text-decoration: underline;
        }

        &.disabled {
          color: #c0c4cc;
          cursor: not-allowed;
          opacity: 0.6;
        }
      }

      :deep(.v-note-wrapper) {
        z-index: auto;
        min-height: auto !important;

        .v-note-panel {
          border: none;
        }

        .v-note-preview-wrapper {
          padding: 12px 16px;
          background-color: #f5f7fa;
          border-radius: 12px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
        }
      }
    }

    &.user {
      flex-direction: row-reverse;

      .avatar {
        margin-right: 0;
        margin-left: 12px;
        background-color: #e6f7ff;
      }

      .content {
        background-color: #3366ff;
        color: #fff;
        padding: 12px 16px;
        border-radius: 12px 2px 12px 12px;
        box-shadow: 0 2px 6px rgba(51, 102, 255, 0.2);
      }
    }

    &.assistant .content {
      :deep(.v-note-preview-wrapper) {
        border-radius: 2px 12px 12px 12px;
      }
    }
  }
}

.chat-input {
  display: flex;
  gap: 8px;
  margin-bottom: 0;
  padding-bottom: 0;

  .el-button {
    border-radius: 8px;
    height: 40px;
    padding: 0 20px;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(51, 102, 255, 0.3);
    }
  }

  .el-autocomplete {
    .el-input__inner {
      border-radius: 8px;
      height: 40px;
    }
  }

  .el-select {
    .el-input__inner {
      border-radius: 8px;
      height: 40px;
    }
  }
}

.top-title {
  display: flex;
  height: 40px;
  line-height: 40px;
  margin-left: 25px;
  margin-bottom: 20px;
  div {
    margin-right: 10px;
    span {
      font-weight: bold;
    }
  }
}

.aside-container {
  &::-webkit-scrollbar {
    display: none; // Chrome, Safari, Edge
  }
  -ms-overflow-style: none; // IE and Edge
  scrollbar-width: none; // Firefox
}

.operation-bar {
  margin-bottom: 10px;
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .operation-bar-title {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: black;
    display: flex;
    align-items: center;

    i {
      margin-right: 6px;
    }
  }

  .el-button {
    border-radius: 8px;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(51, 102, 255, 0.3);
    }
  }
}

.typing-indicator {
  padding: 12px 16px;
  background-color: #f5f7fa;
  border-radius: 2px 12px 12px 12px;
  display: flex;
  gap: 3px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);

  span {
    width: 8px;
    height: 8px;
    background-color: #3366ff;
    opacity: 0.7;
    border-radius: 50%;
    animation: typing 1s infinite;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes typing {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

.suggestion-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;

  .suggestion-type {
    font-size: 12px;
    color: #fff;
    margin-left: 10px;
    background-color: #3366ff;
    padding: 0 10px;
    border-radius: 4px;
  }
}
</style>
